import React, {Component} from 'react'


class NoQuest extends Component{
    
    render(){
        return(                
            <div class="card my-3 p-5 text-center">
                <h4 className="text-muted font-weight-bold">No Question Yet</h4>
            </div>
        )
    }
}

export default NoQuest;